import { __decorate } from "tslib";
import { memoized } from "@buildwithflux/shared";
import { minBy } from "lodash";
import { compactNumberFormatter, formatPackagingOption, humanizeLifecycleStatus, normalizeLifecycleStatus, } from "../formatters";
import { PricingRecord } from "./base";
export class SKURecord extends PricingRecord {
    get formattedAvailableQuantity() {
        if (this.availableQuantity >= 0) {
            return compactNumberFormatter.format(this.availableQuantity);
        }
        return "N/A";
    }
    get minPriceBreak() {
        return minBy(this.priceBreaks, "unitPrice");
    }
    get formattedMinimumOrderQuantity() {
        return compactNumberFormatter.format(this.minimumOrderQuantity);
    }
    get formattedPackagingOptions() {
        return this.packagingOptions.map(formatPackagingOption).join(", ");
    }
    get distributor() {
        return this.entry?.distributor ?? "";
    }
    get dpn() {
        return this.entry?.dpn ?? "";
    }
    get availableQuantity() {
        return this.entry?.availableQuantity ?? -1;
    }
    get unitPrice() {
        return this.minPriceBreak?.unitPrice ?? NaN;
    }
    get priceBreaks() {
        return this.entry?.priceBreaks ?? [];
    }
    get packagingOptions() {
        return this.entry?.packagingOptions ?? [];
    }
    get minimumOrderQuantity() {
        return this.entry?.minimumOrderQuantity ?? 1;
    }
    get leadTimeDays() {
        return this.entry?.leadTimeDays ?? null;
    }
    get listingUrl() {
        return this.entry?.listingUrl ?? null;
    }
    get lifeCycleStatus() {
        return normalizeLifecycleStatus(this.entry?.lifecycleStatus);
    }
    get humanizedLifeCycleStatus() {
        return humanizeLifecycleStatus(this.lifeCycleStatus);
    }
    get lifeCycleState() {
        if (this.lifeCycleStatus === "end_of_life") {
            return "error";
        }
        else if (this.lifeCycleStatus === "not_recommended_for_new_designs") {
            return "warning";
        }
    }
    get humanizedLifeCycleState() {
        if (this.lifeCycleStatus === "error") {
            return "End of Life";
        }
        else if (this.lifeCycleStatus === "warning") {
            return "Not Recommended for New Designs";
        }
    }
}
__decorate([
    memoized
], SKURecord.prototype, "formattedAvailableQuantity", null);
__decorate([
    memoized
], SKURecord.prototype, "minPriceBreak", null);
__decorate([
    memoized
], SKURecord.prototype, "formattedMinimumOrderQuantity", null);
__decorate([
    memoized
], SKURecord.prototype, "formattedPackagingOptions", null);
//# sourceMappingURL=sku.js.map